export default "__VITE_ASSET__DYjYn4wb__"